import { render } from "./SideBar.vue?vue&type=template&id=7f034d9a"
import script from "../js/sideBar.js?vue&type=script&lang=js&external"
export * from "../js/sideBar.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__